import http from "../http-common";

class FeedbackDataService {


  createFeedback(data) {
    return http.post("/feedbacks", data);
  }

  getAll() {
    return http.get("/feedbacks");
  }

  get(id) {
    return http.get(`/feedbacks/${id}`);
  }


}

export default new FeedbackDataService();